import { DESKTOP, TABLET_PORTRAIT, XX_LARGE } from 'src/client/constants/mediaQueries';
import styled, { css } from 'styled-components/macro';

export const TEXT_SHADOW_LARGE = css`
  text-shadow: 0px 4px 24px #000;
`;

export const TEXT_SHADOW_SMALL = css`
  text-shadow: 0px 4px 14px #000;
`;

export const HighlightText = styled.div`
  font-weight: 800;
  color: ${(props) => props.theme.primaryBtn1Bg};
  max-width: 90%;
  font-size: 20px;
  line-height: 1.2;
  display: inline-flex;
  text-align: center;
  align-items: center;

  br {
    display: none;
  }

  @media ${TABLET_PORTRAIT} {
    font-size: 26px;

    br {
      display: block;
    }
  }

  @media ${DESKTOP} {
    font-size: 38px;
  }

  @media ${XX_LARGE} {
    font-size: 52px;
  }
`;

export const SectionTitle = styled.div`
  color: ${(props) => props.theme.primaryBtn1Bg};
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;
  line-height: 1.2;

  @media ${TABLET_PORTRAIT} {
    text-align: left;
    font-size: 24px;

    br {
      display: none;
    }
  }

  @media ${DESKTOP} {
    font-size: 36px;
  }

  @media ${XX_LARGE} {
    font-size: 52px;
  }
`;

export const DescriptionText = styled.div<{ fullWidth?: boolean }>`
  color: ${(props) => props.theme.primary4};
  opacity: 0.6;
  font-size: 14px;
  line-height: 1.2;
  text-align: center;
  margin: 0 auto;
  max-width: ${(props) => (props.fullWidth ? '100%' : '90%')};

  @media ${TABLET_PORTRAIT} {
    text-align: left;
    margin: 0;

    br {
      display: none;
    }
  }

  @media ${DESKTOP} {
    font-size: 18px;
  }

  @media ${XX_LARGE} {
    font-size: 24px;
  }
`;

export const PillButton = styled.span`
  --height: 30px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  height: var(--height);
  padding: 0 calc(var(--height) / 2);
  border-radius: calc(var(--height) / 2);
  cursor: pointer;
  max-width: max-content;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }

  @media ${TABLET_PORTRAIT} {
    font-size: 14px;
  }

  @media ${DESKTOP} {
    font-size: 16px;
    --height: 40px;
  }
`;

export const BrandedPillButton = styled(PillButton)`
  background-color: var(--brand-color);
  color: #000;
  font-weight: 600;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.4);

  --height: 40px;
  font-size: 14px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--brand-hover-color);
    color: #000;
  }

  &:focus {
    background-color: var(--brand-color);
    color: #000;
  }

  @media ${DESKTOP} {
    --height: 64px;
    font-size: 18px;
  }

  @media ${XX_LARGE} {
    font-size: 20px;
  }
`;
